module.exports = __webpack_public_path__ + "img/goods6_4.fd52e9f9.jpg";